function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "currentcolor",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10.186.278A9.916 9.916 0 0 0 .271 9.907v4.67a5.51 5.51 0 0 0 5.509 5.51h4.495a9.906 9.906 0 0 0 9.827-10.313C19.882 4.663 15.739.52 10.649.278h-.463zm0 0v1.101h.42c4.516.199 8.196 3.923 8.394 8.44a8.811 8.811 0 0 1-2.424 6.433 8.74 8.74 0 0 1-6.301 2.733H5.78a4.332 4.332 0 0 1-3.107-1.3 4.382 4.382 0 0 1-1.3-3.13v-4.67a8.781 8.781 0 0 1 2.666-6.06 8.912 8.912 0 0 1 6.147-2.446V.278z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.79 5.985a.93.93 0 0 1 .308-.727c.199-.177.463-.265.794-.265.352 0 .617.088.815.265a.93.93 0 0 1 .308.727c0 .286-.11.529-.308.683-.198.176-.485.264-.815.264a1.23 1.23 0 0 1-.794-.264c-.198-.154-.308-.375-.308-.683zM8.644 9.047v-.462c.132-.044.309-.11.551-.177.22-.066.463-.11.727-.154.265-.044.507-.088.75-.11.242-.022.462-.044.66-.044l.243.154-1.234 5.84h.947v.484c-.11.088-.264.154-.419.242-.154.066-.33.133-.506.199s-.353.11-.529.132a4.312 4.312 0 0 1-.507.044c-.352 0-.573-.066-.705-.199a.623.623 0 0 1-.198-.44c0-.176.022-.353.044-.529.022-.176.066-.353.11-.573l.925-4.208-.859-.199z"
}));

const SvgIcInfo = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcInfo, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic-info.11baab86.svg";
export { ForwardRef as ReactComponent };